import apiurl from './apiurl';
const axios = require('axios');

const empresas= {
    getEmpresas: async (idToken) =>        
    axios({
        'method':'GET',
        'url':apiurl +'empresasName',
        'headers': {
            'content-type':'application/json',
            'Authorization':"Bearer "+idToken
        },
        'crossdomain': true,
    })
    
};

export default empresas;